//old code 

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";

// function AddVehicles() {
//   const navigate = useNavigate();

//   const [modelYear, setModelYear] = useState("");
//   const [self, setSelf] = useState(false);
//   const [ownerID, setOwnerID] = useState(""); // store OwnerID
//   const [vehicleNo, setVehicleNo] = useState("");
//   const [vehicleTypeID, setVehicleTypeID] = useState("");
//   const [vehicleTypes, setVehicleTypes] = useState([]);
//   const [owners, setOwners] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const res = await axios.get("http://localhost:5000/api/vehicles/dropdowns");

//         // Sort Owners alphabetically by OwnerName
//         const sortedOwners = res.data.owners.sort((a, b) =>
//           a.OwnerName.localeCompare(b.OwnerName)
//         );

//         // Sort Vehicle Types alphabetically by VehicleTypeName
//         const sortedVehicleTypes = res.data.vehicleTypes.sort((a, b) =>
//           a.VehicleTypeName.localeCompare(b.VehicleTypeName)
//         );

//         setOwners(sortedOwners);
//         setVehicleTypes(sortedVehicleTypes);
//       } catch (err) {
//         console.error(err);
//         toast.error("Failed to load dropdowns");
//       }
//     };
//     fetchDropdowns();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const payload = {
//         ModelYear: modelYear,
//         Self: self ? 1 : 0, // store 1 for Yes, 0 for No
//         OwnerID: ownerID,
//         VehicleNo: vehicleNo,
//         VehicleTypeID: vehicleTypeID,
//       };

//       await axios.post("http://localhost:5000/api/vehicles", payload);

//       toast.success("Vehicle added successfully!");
//       setTimeout(() => navigate("/Vehicles"), 1000);

//       // Reset form fields
//       setModelYear("");
//       setSelf(false);
//       setOwnerID("");
//       setVehicleNo("");
//       setVehicleTypeID("");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to add vehicle");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-center" autoClose={2000} />
//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Add New Vehicle</h5>

//         <div className="compney_input_div">
//           <label className="mb-2">Model Year</label>
//           <input
//             id="modelYear"
//             className="modelYear"
//             type="number"
//             placeholder="Enter Model Year"
//             required
//             value={modelYear}
//             onChange={(e) => setModelYear(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Self</label>
//           <select
//             id="self"
//             className="self"
//             value={self ? "Yes" : "No"}
//             onChange={(e) => setSelf(e.target.value === "Yes")}
//           >
//             <option value="No">No</option>
//             <option value="Yes">Yes</option>
//           </select>
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Owner Name</label>
//           <select
//             id="ownerID"
//             className="ownerID"
//             value={ownerID}
//             onChange={(e) => setOwnerID(e.target.value)}
//             required
//           >
//             <option value="">Select Owner</option>
//             {owners.map((o) => (
//               <option key={o.HEAD_CODE} value={o.HEAD_CODE}>
//                 {o.OwnerName}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Vehicle Number</label>
//           <input
//             id="vehicleNo"
//             className="vehicleNo"
//             type="text"
//             placeholder="Enter Vehicle Number"
//             required
//             value={vehicleNo}
//             onChange={(e) => setVehicleNo(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Vehicle Type</label>
//           <select
//             id="vehicleTypeID"
//             className="vehicleTypeID"
//             value={vehicleTypeID}
//             onChange={(e) => setVehicleTypeID(e.target.value)}
//             required
//           >
//             <option value="">Select Vehicle Type</option>
//             {vehicleTypes.map((vt) => (
//               <option key={vt.ID} value={vt.ID}>
//                 {vt.VehicleTypeName}
//               </option>
//             ))}
//           </select>
//         </div>

//         <button
//           type="submit"
//           disabled={loading}
//           className="bg-blue-500 text-white px-4 py-2 rounded mt-4 w-full"
//         >
//           {loading ? "Submitting..." : "Submit"}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default AddVehicles;




//new update

import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import axios from "axios";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

function AddVehicles() {
  const navigate = useNavigate();

  const [modelYear, setModelYear] = useState("");
  const [self, setSelf] = useState(0); // 1 for Self, 0 for Others
  const [ownerID, setOwnerID] = useState(""); 
  const [vehicleNo, setVehicleNo] = useState("");
  const [vehicleTypeID, setVehicleTypeID] = useState("");
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [compID, setCompID] = useState(null);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // Fetch dropdowns
  // useEffect(() => {
  //   const fetchDropdowns = async () => {
  //     try {
  //       // const res = await axios.get("http://localhost:5000/api/vehicles/dropdowns");
  //       // const res = await axios.get("https://etour.responseinfoway.com/api/vehicles/dropdowns");
  //       const response = await axios.get(`${BASE_API_URL}/vehicles/dropdowns`);
  //       setOwners(response.data.owners.sort((a, b) => a.OwnerName.localeCompare(b.OwnerName)));
  //       setVehicleTypes(response.data.vehicleTypes.sort((a, b) => a.VehicleTypeName.localeCompare(b.VehicleTypeName)));
  //     } catch (err) {
  //       console.error(err);
  //       toast.error("Failed to load dropdowns");
  //     }
  //   };
  //   fetchDropdowns();
  // 🔹 Get CompID & watch for changes
  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("selectedCompany"));
    if (company?.id) {
      setCompID(company.id);
    }

    const interval = setInterval(() => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      if (company?.id && company.id !== compID) {
        setCompID(company.id);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [compID]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        if (!compID) return;

        const response = await axios.get(
          `${BASE_API_URL}/vehicles/dropdowns/${compID}`
        );

        if (!response.data.success) return;

        const sortedOwners = (response.data.owners || []).sort((a, b) =>
          (a.OwnerName || a.HEADName || "").localeCompare(b.OwnerName || b.HEADName || "")
        );

        const sortedVehicleTypes = (response.data.vehicleTypes || []).sort((a, b) =>
          (a.VehicleTypeName || a.VTYPE || "").localeCompare(b.VehicleTypeName || b.VTYPE || "")
        );

        setOwners(sortedOwners);
        setVehicleTypes(sortedVehicleTypes);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdowns();
  }, [compID]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!vehicleNo || !vehicleNo.trim()) {
      showToast.warn("Please enter a Vehicle Number");
      return;
    }

    if (!vehicleTypeID) {
      showToast.warn("Please select a Vehicle Type");
      return;
    }

    if (!ownerID) {
      showToast.warn("Please select an Owner");
      return;
    }

    setLoading(true);

    try {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));

      if (!company?.id) {
        showToast.warn("Please select a company first.");
        setLoading(false);
        return;
      }

      const payload = {
        vehicleNumber: vehicleNo.trim(),
        vehicleType: vehicleTypeID,
        ownerID: ownerID,
        modelYear: modelYear ? parseInt(modelYear) : null,
        self: parseInt(self) === 1 ? 1 : 0,
        Self: parseInt(self) === 1 ? 1 : 0,
        CompID: company.id
      };

      // ============================
      // API with Logging (Node)
      // ============================
      const res = await apiWithLog({
        method: "POST",
        url: `${BASE_API_URL}/vehicles/create`,
        data: payload,
        module: "VehicleMaster",
        action: "A",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;

      if ((res.status === 200 || res.status === 201) && (result?.status || result?.success)) {
        showToast.save("Vehicle added successfully!");

        // Clear form
        setVehicleNo("");
        setVehicleTypeID("");
        setOwnerID("");
        setModelYear("");
        setSelf(0);

        // Redirect
        setTimeout(() => navigate("/Vehicles"), 1200);
      } else {
        showToast.error(result?.message || "Failed to add vehicle");
      }

    } catch (err) {
      console.error("Vehicle Add Error:", err);
      showToast.error(
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to add vehicle"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Add Vehicle</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/Vehicles">Vehicles</Link>
            <span>/</span>
            <span>New</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Vehicle Information</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            <div className="update_ledger_field">
              <label htmlFor="vehicleNo">
                Vehicle Number <span className="required">*</span>
              </label>
              <input
                id="vehicleNo"
                type="text"
                placeholder="e.g. RJ14TC1234"
                required
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
              />
            </div>

            <div className="update_ledger_field">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                <label htmlFor="vehicleTypeID" style={{ margin: 0 }}>
                  Vehicle Type <span className="required">*</span>
                </label>
                <Link
                  to="/vehicletype"
                  style={{
                    fontSize: "12px",
                    color: "#0f766e",
                    fontWeight: "600",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px"
                  }}
                  title="Add New Vehicle Type"
                >
                  <i className="fa-solid fa-plus-circle"></i> + Add Vehicle Type
                </Link>
              </div>
              <select
                id="vehicleTypeID"
                value={String(vehicleTypeID || "")}
                onChange={(e) => setVehicleTypeID(e.target.value)}
                required
              >
                <option value="">-- Select Vehicle Type --</option>
                {vehicleTypes.map((vt) => {
                  const val = String(vt.VehicleTypeID || vt.ID || "");
                  const label = vt.VehicleTypeName || vt.VTYPE || "";
                  return (
                    <option key={val} value={val}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="update_ledger_field">
              <label style={{ marginBottom: "6px" }}>
                Ownership <span className="required">*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#f1f5f9",
                  padding: "3px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  height: "38px",
                  boxSizing: "border-box",
                  width: "100%",
                }}
              >
                <button
                  type="button"
                  onClick={() => setSelf(1)}
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: self === 1 ? "700" : "500",
                    backgroundColor: self === 1 ? "#0f766e" : "transparent",
                    color: self === 1 ? "#ffffff" : "#475569",
                    boxShadow: self === 1 ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                    transition: "all 0.15s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa-solid fa-car" style={{ fontSize: "12px" }}></i> Self
                </button>
                <button
                  type="button"
                  onClick={() => setSelf(0)}
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: self === 0 ? "700" : "500",
                    backgroundColor: self === 0 ? "#0f766e" : "transparent",
                    color: self === 0 ? "#ffffff" : "#475569",
                    boxShadow: self === 0 ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                    transition: "all 0.15s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa-solid fa-users" style={{ fontSize: "12px" }}></i> Others
                </button>
              </div>
            </div>

            <div className="update_ledger_field">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                <label htmlFor="ownerID" style={{ margin: 0 }}>
                  Owner Name <span className="required">*</span>
                </label>
                <Link
                  to="/AddLedger"
                  state={{ defaultGroup: 23, defaultGroupName: "Sundry Creditors", fromVehicle: true }}
                  style={{
                    fontSize: "12px",
                    color: "#0f766e",
                    fontWeight: "600",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px"
                  }}
                  title="Add New Owner (Sundry Creditors)"
                >
                  <i className="fa-solid fa-plus-circle"></i> + Add Owner
                </Link>
              </div>
              <select
                id="ownerID"
                value={String(ownerID || "")}
                onChange={(e) => setOwnerID(e.target.value)}
                required
              >
                <option value="">-- Select Owner (Sundry Creditor) * --</option>
                {owners.map((o) => {
                  const val = String(o.HEAD_CODE || o.OwnerID || "");
                  const label = o.OwnerName || o.HEADName || "";
                  return (
                    <option key={val} value={val}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="update_ledger_field">
              <label htmlFor="modelYear">
                Model Year
              </label>
              <input
                id="modelYear"
                type="number"
                placeholder="e.g. 2024 (Optional)"
                value={modelYear}
                onChange={(e) => setModelYear(e.target.value)}
              />
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/Vehicles" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Vehicle"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddVehicles;
